import { render, staticRenderFns } from "./CartRemoveButton.vue?vue&type=template&id=21da8c3f"
import script from "./CartRemoveButton.vue?vue&type=script&lang=js"
export * from "./CartRemoveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports